import { Card, Lang, Nullable, ProjectUtils, TFile } from "@brg/api";
import { ImageRequest } from "shared/constants/imageRequest";

export interface ComputedCard {
    projectId: string,
    identifier: string,
    status: number | undefined,
    title: string,
    image?: string | undefined,
    titleImages?: TFile[],
    titleImages_en?: TFile[],
    isCard: boolean
}

export function computeCard(project: Nullable<Partial<Card>>): ComputedCard {
    // @ts-ignore
    const image = ProjectUtils.getTitleImageOrUndefined(project, ImageRequest.tile);

    return {
        projectId: project?.cardId ?? 'undefined',
        identifier: project?.cardId ?? 'undefined',
        status: project?.statusCard ?? 0,
        title: project?.name ?? 'untitled',
        image: image || 'undefined',
        titleImages: project?.images || [],
        titleImages_en: project?.images || [],
        isCard: true
    };
}import { Card, Lang, Nullable, ProjectUtils, TFile } from "@brg/api";
import { ImageRequest } from "shared/constants/imageRequest";

export interface ComputedCard {
    projectId: string,
    identifier: string,
    status: number | undefined,
    title: string,
    image?: string | undefined,
    titleImages?: TFile[],
    titleImages_en?: TFile[],
    isCard: boolean
}

export function computeCard(project: Nullable<Partial<Card>>): ComputedCard {
    // @ts-ignore
    const image = ProjectUtils.getTitleImageOrUndefined(project, ImageRequest.tile);

    return {
        projectId: project?.cardId ?? 'undefined',
        identifier: project?.cardId ?? 'undefined',
        status: project?.statusCard ?? 0,
        title: project?.name ?? 'untitled',
        image: image || 'undefined',
        titleImages: project?.images || [],
        titleImages_en: project?.images || [],
        isCard: true
    };
}